require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-8-retargeting-hacks-for-facebook-and-instagram.json") })
        }
      }, "path---blog-8-retargeting-hacks-for-facebook-and-instagram");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-8-retargeting-hacks-for-facebook-and-instagram!./.cache/json/blog-8-retargeting-hacks-for-facebook-and-instagram.json
// module id = 418
// module chunks = 231608221292675